<script setup lang="ts">
const { updateUrlQueryParams } = useGlobalFilters()
const linkIsReady = ref(false)
async function createAndCopyLink() {
  updateUrlQueryParams()
  linkIsReady.value = true
  const url = window.location.href
  try {
    await navigator.clipboard.writeText(url)
  } catch (error) {
    alert('Kunde inte kopiera länken')
  }
}
function openInNewWindow() {
  window.open(window.location.href, '_blank')
}
</script>
<template>
  <p>Skapa en länk till kartan med aktuell kartvy och relaterade filterinställningar</p>
  <div class="mb-2">
    <Button icon="pi pi-copy" label="Skapa och kopiera länk" rounded @click="createAndCopyLink()" />
  </div>
  <div v-if="linkIsReady" class="mb-2">
    <Button
      icon="pi pi-copy"
      label="Öppna i nytt fönster"
      size="small"
      outlined
      rounded
      @click="openInNewWindow()"
    />
  </div>
</template>
